export interface BatchStatisticsDeletePredefinedItemRequest {
  batchType: string
  deleteItem: string
}

export function BatchStatisticsDeletePredefinedItemRequestToJSON(
  value: BatchStatisticsDeletePredefinedItemRequest
): any {
  return {
    batch_type: value.batchType,
    delete_item: value.deleteItem
  }
}
